import { HEAD_DOCTOR_COPY } from '../head-doctor/headDoctorCopy';
import { NURSE_COPY } from '../nurse/nurseCopy';

const MAJOR_BADGE = 'Chef infirmerie';

function withMajorBadge(section, extras = {}) {
  return { ...section, BADGE: MAJOR_BADGE, ...extras };
}

export const MAJOR_COPY = {
  ...NURSE_COPY,

  LAYOUT: {
    ...NURSE_COPY.LAYOUT,
    NAVBAR_BRAND: 'Major infirmerie',
    SIDE_MENU_SECTION: 'Chef de service infirmier',
    SIDE_CATALOG_SECTION: 'Référentiels infirmerie',
    ACCOUNT_MENU_ARIA: 'Menu du compte major infirmerie',
    CHANGE_SITE_CHIP_TITLE: 'Changer le site de travail',
    SITE_ACTIVE_TOAST: 'Site actif : {name}',
    SITE_GATE_DESC:
      'Sélectionnez le site où vous exercez en tant que major. La file, les passages et les référentiels infirmerie utiliseront ce site pour cette session.',
    SIDEBAR_TOGGLE_COLLAPSED: 'Déplier le menu major',
    SIDEBAR_TOGGLE_EXPANDED: 'Replier le menu major',
    SITE_CARD_META_FALLBACK: 'Site de travail'
  },

  NAV: {
    ...NURSE_COPY.NAV,
    catalogSoins: {
      label: 'Catalogue soins',
      hint: 'Actes de soins proposés au poste'
    },
    catalogTests: {
      label: 'Catalogue tests',
      hint: 'Tests rapides infirmerie'
    },
    catalogInjection: {
      label: 'Catalogue injections',
      hint: 'Actes d’injection proposés au poste'
    },
    catalogVaccins: {
      label: 'Catalogue vaccins',
      hint: 'Référentiel vaccinal SMIE'
    },
    catalogPlanningFamilial: {
      label: 'Planning familial',
      hint: 'Actes de planification familiale au poste'
    },
    reports: {
      label: 'Rapports infirmerie',
      hint: 'Synthèse, soins, injections, tests, vaccins et planning familial'
    },
    reportsOverview: { icon: 'chartBar' },
    reportsSoins: { icon: 'heart' },
    reportsInjections: { icon: 'syringe' },
    reportsTests: { icon: 'check' },
    reportsVaccins: { icon: 'shield' },
    reportsPlanningFamilial: { icon: 'users' }
  },

  DASHBOARD: {
    ...NURSE_COPY.DASHBOARD,
    BADGE: MAJOR_BADGE,
    OPS_BADGE: 'Poste infirmier',
    PAGE_TITLE: 'Tableau de bord major',
    PAGE_SUBTITLE:
      'Poste infirmier, file du site et gestion des référentiels soins, tests, injections, vaccins et planning familial.',
    QUICK_SUBTITLE: 'Navigation rapide · accueil, file, historique et aide.',
    HUB_TITLE: 'Référentiels infirmerie',
    HUB_SUBTITLE: 'Catalogues que vous administrez pour le poste infirmier.',
    BADGE_READY: 'Actif'
  },

  HUB_CARDS: [
    {
      kind: 'route',
      routeKey: 'SOINS_INFIRMERIE',
      pathKey: 'SOINS',
      title: 'Soins infirmerie',
      subtitle: 'Catalogue des actes de soins proposés au poste',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'TESTS_INFIRMERIE',
      pathKey: 'TESTS',
      title: 'Tests infirmerie',
      subtitle: 'Tests rapides réalisés au poste infirmier',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'INJECTION_INFIRMERIE',
      pathKey: 'INJECTION',
      title: 'Injections infirmerie',
      subtitle: 'Catalogue des injections proposées au poste',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'VACCINS',
      pathKey: 'VACCINS',
      title: 'Vaccins',
      subtitle: 'Référentiel vaccinal institutionnel SMIE',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'PLANIFICATION_FAMILIALE',
      pathKey: 'PLANNING_FAMILIAL',
      title: 'Planning familial',
      subtitle: 'Catalogue des actes de planification familiale',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'STATISTIQUES',
      pathKey: 'RAPPORTS',
      title: 'Rapports infirmerie',
      subtitle: 'Passages, soins, injections, tests, vaccins et planning familial',
      badge: 'ready'
    }
  ],

  REPORTS: {
    ...HEAD_DOCTOR_COPY.REPORTS,
    BADGE: 'Rapports infirmerie',
    TITLE: 'Rapports infirmerie',
    DESCRIPTION:
      'Pilotage du poste infirmier : filtrez par site, période, patient ou acte, puis ouvrez la synthèse ou une statistique (soins, injections, tests, vaccins, planning familial).',
    SUBNAV_GROUP_NURSING: 'Statistiques infirmerie',
    SUB_OVERVIEW: 'Synthèse',
    SUB_SOINS: 'Soins',
    SUB_INJECTIONS: 'Injections',
    SUB_TESTS: 'Tests',
    SUB_VACCINS: 'Vaccins',
    SUB_PLANNING_FAMILIAL: 'Planning familial',
    PAGE_OVERVIEW_TITLE: 'Journal des actes infirmerie',
    PAGE_OVERVIEW_DESC:
      'Liste chronologique des soins, tests, vaccinations et actes de planning familial : date, identité patient, société, type adhérent et acte.',
    SYNTHESIS_EXPORT: 'Export CSV',
    SYNTHESIS_EXPORTING: 'Export…',
    SYNTHESIS_PER_PAGE: 'Lignes/page',
    SYNTHESIS_PAGE_STATUS: (page, totalPages, total) =>
      `Page ${Number(page || 1)} / ${Number(totalPages || 1)} · ${Number(total || 0).toLocaleString('fr-FR')} lignes`,
    SYNTHESIS_COUNT: (count) =>
      `${Number(count || 0).toLocaleString('fr-FR')} acte${Number(count || 0) > 1 ? 's' : ''}`,
    COL_DATE: 'Date',
    COL_NOM: 'Nom',
    COL_PRENOM: 'Prénom',
    COL_SOCIETE: 'Société',
    COL_MATRICULE: 'Matricule',
    COL_TYPE: 'Type',
    COL_SEXE: 'Sexe',
    COL_AGE: 'Âge',
    COL_ACTE: 'Acte',
    COL_INJECTION: 'Injection',
    COL_PLANNING_FAMILIAL: 'Planning familial',
    EMPTY_SYNTHESIS: 'Aucun acte infirmerie sur la période sélectionnée.',
    EMPTY_SYNTHESIS_HINT:
      'Essayez d’élargir la période, de retirer un filtre patient/acte ou de sélectionner un autre site autorisé.',
    EMPTY_FILTERED_HINT:
      'Ajustez les filtres actifs pour élargir les résultats, puis relancez l’analyse.',
    EMPTY_CLEAR_FILTERS: 'Effacer les filtres avancés',
    ERROR_SYNTHESIS_LOAD: 'Impossible de charger le journal des actes.',
    RETRY_LABEL: 'Réessayer',
    CONTEXT_SITE_LABEL: 'Site',
    CONTEXT_PERIOD_LABEL: 'Période',
    PAGE_SOINS_TITLE: 'Statistiques des soins',
    PAGE_SOINS_DESC: 'Actes de soins infirmiers réalisés — fréquence par catalogue.',
    PAGE_INJECTIONS_TITLE: 'Statistiques des injections',
    PAGE_INJECTIONS_DESC: 'Actes d\'injection réalisés en infirmerie — fréquence par type.',
    PAGE_TESTS_TITLE: 'Statistiques des tests',
    PAGE_TESTS_DESC: 'Tests rapides infirmerie — fréquence et résultats enregistrés.',
    PAGE_VACCINS_TITLE: 'Statistiques des vaccins',
    PAGE_VACCINS_DESC: 'Vaccinations administrées en infirmerie — fréquence par vaccin du catalogue.',
    PAGE_PLANNING_FAMILIAL_TITLE: 'Statistiques planning familial',
    PAGE_PLANNING_FAMILIAL_DESC:
      'Actes de planning familial réalisés en infirmerie — fréquence par type du catalogue.',
    ERROR_NO_SITE: 'Aucun site de travail affecté à votre profil.',
    FILTER_ALL_SITES: 'Tous les sites',
    FILTER_PRIMARY_ARIA: 'Filtres patient et actes',
    FILTER_TAB_SCOPE_PREFIX: 'Vue limitée aux',
    FILTER_AGE_TOGGLE: 'Tranche d\'âge',
    FILTER_RESET: 'Réinitialiser les filtres',
    FILTER_PATIENT_SEARCH: 'Patient',
    FILTER_PATIENT_SEARCH_PH: 'Nom, prénom ou matricule…',
    FILTER_COMPANY: 'Société',
    FILTER_COMPANY_ALL: 'Toutes les sociétés',
    FILTER_MEMBER_TYPE: 'Type adhérent',
    FILTER_MEMBER_TYPE_ALL: 'Tous',
    FILTER_MEMBER_TYPE_A: 'Agent (A)',
    FILTER_MEMBER_TYPE_C: 'Conjoint (C)',
    FILTER_MEMBER_TYPE_E: 'Enfant (E)',
    FILTER_MEMBER_TYPE_EXT: 'Externe',
    FILTER_SEX: 'Sexe',
    FILTER_SEX_ALL: 'Tous',
    FILTER_SEX_M: 'Homme',
    FILTER_SEX_F: 'Femme',
    FILTER_ACT_KIND: 'Nature d\'acte',
    FILTER_ACT_KIND_ALL: 'Tous les actes',
    FILTER_ACT_KIND_CARE: 'Soins',
    FILTER_ACT_KIND_INJECTION: 'Injections',
    FILTER_ACT_KIND_TEST: 'Tests',
    FILTER_ACT_KIND_VACCINE: 'Vaccins',
    FILTER_ACT_KIND_FAMILY_PLANNING: 'Planning familial',
    FILTER_ACT_SEARCH: 'Acte',
    FILTER_ACT_SEARCH_PH: 'Libellé soin, test, vaccin ou planning familial…',
    FILTER_AGE_MIN: 'Âge min',
    FILTER_AGE_MAX: 'Âge max',
    FILTER_AGE_PRESETS: 'Raccourcis',
    FILTER_AGE_PRESETS_ARIA: 'Raccourcis de tranche d\'âge',
    FILTER_AGE_CHILD: 'Enfant (<18)',
    FILTER_AGE_ADULT: 'Adulte (18–59)',
    FILTER_AGE_SENIOR: 'Senior (60+)',
    FILTER_ACTIVE_ARIA: 'Filtres actifs',
    FILTER_CHIP_REMOVE: 'Retirer ce filtre',
    CONTEXT_FILTERS: (count) =>
      `${Number(count || 0)} filtre${Number(count || 0) > 1 ? 's' : ''} actif${Number(count || 0) > 1 ? 's' : ''}`,
    CHIP_PATIENT: 'Patient',
    CHIP_ACT: 'Acte',
    CHIP_COMPANY: 'Société',
    CHIP_MEMBER_TYPE: 'Type',
    CHIP_SEX: 'Sexe',
    CHIP_TAB_SCOPE: 'Vue',
    CHIP_ACT_KIND: 'Nature',
    CHIP_AGE: 'Âge'
  },

  GUIDE: {
    ...NURSE_COPY.GUIDE,
    PAGE_TITLE: 'Aide major infirmerie',
    PAGE_SUBTITLE:
      'Poste infirmier, catalogues et rapports du site : soins, injections, tests, vaccins et planning familial.',
    STEPS: [
      ...(NURSE_COPY.GUIDE.STEPS || []),
      {
        title: '5. Référentiels & rapports',
        text: 'Vous tenez les catalogues du poste et consultez les rapports infirmerie du site (synthèse, soins, injections, tests, vaccins, planning familial).'
      }
    ]
  },

  CARE_CHECKLIST: {
    ...NURSE_COPY.CARE_CHECKLIST,
    EMPTY_CATALOG: 'Catalogue vide — ajoutez des actes dans Référentiels infirmerie.',
    KINDS: {
      ...NURSE_COPY.CARE_CHECKLIST.KINDS,
      care: {
        ...NURSE_COPY.CARE_CHECKLIST.KINDS.care,
        EMPTY_CATALOG: 'Catalogue soins vide — ajoutez des actes dans Référentiels infirmerie.'
      },
      injection: {
        ...NURSE_COPY.CARE_CHECKLIST.KINDS.injection,
        EMPTY_CATALOG: 'Catalogue injections vide — ajoutez des actes dans Référentiels infirmerie.'
      },
      family_planning: {
        ...NURSE_COPY.CARE_CHECKLIST.KINDS.family_planning,
        EMPTY_CATALOG: 'Catalogue planning familial vide — ajoutez des actes dans Référentiels infirmerie.'
      }
    }
  },

  NURSING_CARE_CATALOG: withMajorBadge(HEAD_DOCTOR_COPY.NURSING_CARE_CATALOG, {
    PAGE_SUBTITLE:
      'Référentiel que vous tenez pour le poste : pansements, surveillance et premiers soins proposés en infirmerie.'
  }),
  NURSING_INJECTION_CATALOG: withMajorBadge(HEAD_DOCTOR_COPY.NURSING_INJECTION_CATALOG, {
    PAGE_SUBTITLE:
      'Référentiel des injections proposées au poste infirmier — libellés utilisés à la saisie et dans les rapports.'
  }),
  NURSING_TEST_CATALOG: withMajorBadge(HEAD_DOCTOR_COPY.NURSING_TEST_CATALOG, {
    PAGE_SUBTITLE:
      'Référentiel des tests rapides du poste infirmier — actifs ici, visibles ensuite dans le passage et les statistiques.'
  }),
  VACCINE_CATALOG: withMajorBadge(HEAD_DOCTOR_COPY.VACCINE_CATALOG, {
    PAGE_SUBTITLE:
      'Référentiel vaccinal SMIE du site — vaccins proposés au poste et repris dans les rapports infirmerie.'
  }),
  FAMILY_PLANNING_CATALOG: withMajorBadge(HEAD_DOCTOR_COPY.FAMILY_PLANNING_CATALOG, {
    PAGE_SUBTITLE:
      'Référentiel des actes de planification familiale du poste — tenus ici, saisis ensuite dans le passage.'
  })
};
